import { useVideoCreatorStore } from '@src/stores-v2/VideoCreatorStoreContext';

interface UseFullscreenTransitionResult {
  makeFullScreen: () => Promise<void>;
  exitFullScreen: () => void;
}

export function useFullscreenTransition(): UseFullscreenTransitionResult {
  const videoCreator = useVideoCreatorStore();

  const makeFullScreen = async () => {
    if (videoCreator.isPlayerFullScreen) {
      return;
    }

    videoCreator.isPlayerFullScreen = true;
    videoCreator.renderer?.setMode('player');
  };

  const exitFullScreen = () => {
    videoCreator.renderer?.setMode('interactive');
    videoCreator.isPlayerFullScreen = false;
    videoCreator.renderer?.setTool('text');
  };

  return {
    makeFullScreen,
    exitFullScreen,
  };
}
